var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"microRoot"}),(_vm.errored)?_c('p',[_vm._v("微应用加载出错了")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }